import { __rest, __read, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import * as React from 'react';
import { useField } from 'formik';
import { NvCheckbox } from '@invitae/ids-react';

var NvFormikCheckbox = React.forwardRef(function (_a, ref) {
    var onClick = _a.onClick, name = _a.name, props = __rest(_a, ["onClick", "name"]);
    var _b = __read(useField(name), 3), meta = _b[1], helpers = _b[2];
    var handleClick = React.useCallback(function (isChecked) {
        var checked = !isChecked;
        helpers.setValue(checked);
        onClick === null || onClick === void 0 ? void 0 : onClick(checked);
    }, [helpers, onClick]);
    return React.createElement(NvCheckbox, __assign({}, props, { checked: meta.value, onClick: function () { return handleClick(meta.value); }, ref: ref }));
});
NvFormikCheckbox.displayName = 'NvFormikCheckbox';

export { NvFormikCheckbox as default };
//# sourceMappingURL=NvFormikCheckbox.esm.js.map
